module.exports = __webpack_public_path__ + "static/media/tanque-verde_old.e1b406ac.svg";